/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';

import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

import {
  quarterTest1,
  quarterTest2,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchErrorMsgProvider,
  getRebateProgrameList,
  dispatchPerformResolutionObj,
  dispatchRebateProgramName,
  getPlanTypeValues,
  dispatchFrom,
  dispatchProvider,
  getProvider,
  dispatchDisplayObjBProvider,
} from '../Store/action';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  REBATE_PROGRAM_REQUIRED,
  STATUS_MSG,
  SUCCESS_MSG,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const BProviderClaim = (props) => {
  const dispatch = useDispatch();

  const {
    performResolutionObj: requestCurrentDisData,
    planType: planTypeList,
    selectedPlanType,
    rebateProgram: getRebateProgramList,
    rebateProgramName: getRebateProgramName,
    errorMsgProvider: getErrorMsg,
    quarter: getQuarter,
    provider: getProviderList,
  } = useSelector((state) => state?.sharedState?.BProviderClaimReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });

  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [planTypeOptions, setPlanTypeOptions] = React.useState([]);
  const [quarter, setQuarter] = React.useState(getQuarter);
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [rebateProgramList, setRebateProgramList] = React.useState([]);
  const [radioList, setRadioList] = React.useState([]);
  // local variable

  const [state, setState] = React.useState(
    requestCurrentDisData?.state
      ? requestCurrentDisData?.state
      : {
          planTypeCd: userDefaults?.planTypeCd
            ? selectedPlanType || userDefaults?.planTypeCd
            : 'FD',
          rebateProgramCd: userDefaults?.rebateProgramCd
            ? getRebateProgramName?.rebateProgramCd ||
              userDefaults?.rebateProgramCd
            : '-1',
          quarter: '',
        }
  );
  // dispatch function
  const setPerformScrData = (value) =>
    dispatch(dispatchPerformResolutionObj(value));
  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };
  // Plan type useEffect
  React.useEffect(() => {
    handleScrollToEvent();
    if (!planTypeList?.PLAN_TYPE_CD) {
      dispatch(getPlanTypeValues({}));
    }
  }, []);
  const rebatepgmDropdown = async (planType) => {
    const getRebateProgramList = await dispatch(
      getRebateProgrameList(planType)
    );
    let list = [];
    if (
      getRebateProgramList?.status === STATUS_MSG &&
      getRebateProgramList?.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(getRebateProgramList.data)) {
        list = _.map(getRebateProgramList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  };
  //  setting radioList from planList Api
  React.useEffect(() => {
    if (
      planTypeList &&
      planTypeList.PLAN_TYPE_CD &&
      planTypeList.PLAN_TYPE_CD.length > 0
    ) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
    }
  }, [planTypeList]);
  // get rebate program
  React.useEffect(() => {
    rebatepgmDropdown(state.planTypeCd);
  }, [state.planTypeCd]);

  // handling highlight tab
  React.useEffect(() => {
    if (getErrorMsg && getErrorMsg.length > 0) {
      tabHighLigther('/340BProviderClaims', true);
    } else {
      tabHighLigther('/340BProviderClaims', false);
    }
  }, [getErrorMsg]);
            
  //remove no data error msg
  React.useEffect(() => {
    dispatch(dispatchErrorMsgProvider([]));
  }, [getProviderList, planTypeList, state.planTypeCd, quarter, state.rebateProgramCd ]);

  // on change event on filed
  const handleOnChangeEvent = (value, name) => {
    dispatch(dispatchErrorMsgProvider([]));
    let localErr = getErrorMsg || [];
    if (name === 'planTypeCd') {
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      setPerformScrData({
        state: { ...state, [name]: value, rebateProgramCd: '-1' },
      });
    }
    if (name === 'rebateProgramCd') {
      setState({ ...state, [name]: value });
      setPerformScrData({
        state: { ...state, [name]: value },
      });
    }
    localErr = localErr.filter((item) => item.field != 'rebateProgramCd');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgProvider(unique));
  };
  const handleOnblurEvent = (type, value) => {
    dispatch(dispatchErrorMsgProvider([]));
    let localErr = getErrorMsg || [];
    const data = value;
    if (type === 'quarter') {
      value = autoFormateDate(data);
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'quarterRequired',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          setQuarter(value?.toUpperCase());
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'quarterRequired',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }
    if (type === 'rebateProgramCd') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
    }

    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgProvider(unique));
  };

  const handlefromChange = (event) => {
    dispatch(dispatchErrorMsgProvider([]));
    let { value } = event.target;
    if (value.includes('q')) {
      value = value.replace('q', 'Q');
    }
    setQuarter(value);
    let localErr = getErrorMsg || [];
    localErr = localErr.filter((item) => item.field !== 'startQtr');
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgProvider(unique));
  };

  // on Click to next screen
  const click = () => {
    const rebateProgramName = rebateProgramList.find(
      (item) => item.id == state.rebateProgramCd
    );
    let localErr = getErrorMsg || [];
    if (!quarter) {
      localErr =
        localErr && localErr?.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'quarterRequired',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    if (state.rebateProgramCd === '-1') {
      localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: REBATE_PROGRAM_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(dispatchErrorMsgProvider(unique));
    if (localErr.length == 0) {
      dispatch(dispatchProvider([]));
      setSearchClicked(true);
      dispatch(
        getProvider({
          rebateProgram: rebateProgramName?.rebateProgramCd,
          quarter: quarter,
        })
      );

      dispatch(dispatchRebateProgramName(rebateProgramName));
      dispatch(dispatchFrom(quarter));
      dispatch(
        dispatchDisplayObjBProvider({
          rebateProgramName,
          quarter,
        })
      );
    }
  };
  if (isSearchClicked && getProviderList?.providerClaims340BVO?.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/display340BProviderClaims',
      value: 'Display 340B Provider Claims',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    props.history.push({
      pathname: '/display340BProviderClaims',
    });
    dispatch(clearReduxForFilterAndSort('/display340BProviderClaims'));
  }
  return (
    <div className="tabs-container">
      <Spinner load={spinnerLoader} />
      <CustomSeparator parent1="State Reports" parent2="340B Provider Claims" />
      {getErrorMsg?.length > 0 ? (
        <DisplayErrorMessages
          errorMessages={
            getErrorMsg?.length > 0 ? _.map(getErrorMsg, (l) => l.message) : []
          }
        />
      ) : null}

      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="ProviderClaim_PlanType"
              id="radio-button-for-rcdd_id"
              labelName="Plan Type"
              required
              optionList={radioList || []}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Rebate Program<span className="mandatory"> *</span>
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    name="rebateProgram"
                    id="rebate_program"
                    label="Rebate Program"
                    data-testid="ProviderClaim_rebateProgram"
                    fullWidth
                    select
                    required
                    inputProps={{ maxLength: 11, id: 'rebate_program' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd'
                              ? 'mandate-fields'
                              : null
                          )
                        : null
                    }
                    onBlur={(e) =>
                      handleOnblurEvent('rebateProgramCd', e.target.value)
                    }
                    onChange={(e) =>
                      handleOnChangeEvent(e?.target?.value, 'rebateProgramCd')
                    }
                    value={
                      state && state.rebateProgramCd
                        ? state.rebateProgramCd
                        : ''
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'rebateProgramCd' ? l.message : null
                          )
                        : null
                    }
                  >
                    <MenuItem
                      key=""
                      value="-1"
                      className="frr-dropdown-blank-item"
                    />
                    {rebateProgramList &&
                    rebateProgramList.length &&
                    rebateProgramList.length > 0
                      ? rebateProgramList.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </TextField>
                </div>
              </div>
            </fieldset>
          </div>
          <div className="col-4">
            <fieldset className="custom-fieldset">
              <legend className="same-font-family">
                Quarter<span className="mandatory"> *</span>
              </legend>
              <div className="form-wrapper p-0">
                <div className="mui-custom-form with-select field-xl no-lbl">
                  <TextField
                    label="Quarter"
                    id="check_by_invoice_quater"
                    required
                    fullWidth
                    value={quarter}
                    onChange={handlefromChange}
                    placeholder=""
                    data-testid="ProvidereClaim_Qtr"
                    inputProps={{ maxLength: 6, id: 'check_by_invoice_quater' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    className={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field == 'quarter'
                              ? 'mandate-fields frr-display-hidden-label'
                              : 'frr-display-hidden-label'
                          )
                        : 'frr-display-hidden-label'
                    }
                    onBlur={(e) => handleOnblurEvent('quarter', e.target.value)}
                    helperText={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field === 'quarter' ? l.message : null
                          )
                        : null
                    }
                    error={
                      getErrorMsg?.length > 0
                        ? _.map(getErrorMsg, (l) =>
                            l.field == 'quarter' ? l.message : null
                          )
                        : null
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>

      <div className="col-sm-12">
        <div className="btn-wrapper mb-2">
          <div className="float-right mt-2 hide-on-print">
            <Button
              className="btn btn-success btn-search"
              data-testid="view_detail_ia"
              type="button"
              onClick={click}
            >
              {' '}
              <SVGComponent iconName="Icon-search" /> {'  '} Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BProviderClaim;
